export const VISITOR_ABILITIES = {
  // 工作台
  WORKBENCH: false,
  // 团队
  TEAM: false,
  // 切换空间
  SWITCH_SPACE: false,
  // 分享
  SHARE: false,
  // 复制链接
  COPY_LINK: false,
  // 群聊：建群/加群/群空间
  CHAT_GROUP: false,
  // 新建空间
  CREATE_NEW_PROJECT: false,
  // 综搜
  GLOBAL_SEARCH: false,
  // 个人中心
  USER: false,
  // 帮助中心
  HELPCENTER: false,
  // 空间设置
  SETTING: false,
  // 全景视图
  MULTI_PROJECT_VIEW: false,
  // 度量图表
  CHART: false,
  // 催一催
  URGE: false,
  // 复制并同步
  SYNCHRONOUS_CREATION: false,
  // 复制ID
  COPY_ID: false,
  // 工作项 - 我收藏的
  WORKITEM_FAVORITE_TAB: false,
  // 导出
  EXPORT_CSV: false,
  // 工作项 - 路由按钮
  WORK_ITEM_ROUTER_BUTTONS: false,
  // 工作项 - Collect PIN
  WORK_ITEM_COLLECT_PIN: false,
  // 工作项 - BriefOperation
  WORK_ITEM_BRIEF_OPERATION: false,
  // 工作项 - 节点卡片
  WORK_ITEM_NODE_CARD: false,
  // 评论 at人
  COMMENT_MENTION: false,
  // 工作项完成后 - 再发起评论
  COMMENT_WHEN_FINISHED: false,
};
